
export default {
	name: 'paginate',

	computed: {
		itemsData: function itemsData() {
			return this.page.itemsData || {};
		}
	},

	watch: {
		'$route.query': function $routeQuery() {
			this.$emit('updateItems');
		}
	},

	created: function created() {
		if (this.page.prevPagePath && this.page.prevPagePath !== this.$route.fullPath) {
			this.$emit('updateItems');
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./components/mixins/paginate.js
// module id = ./components/mixins/paginate.js
// module chunks = 0